export default {
  system: {
    user: 'Usuario',
    level: 'Nivel',
    earnPerTap: 'Ganancia por toque',
    coinsToLevelUp: 'Monedas para subir de nivel',
    profitPerHour: 'Ganancia por hora',
    coming1: 'Algo interesante',
    coming2: 'llegará pronto aquí...',
    close: 'Cerrar',
    friends: 'Amigos',
    continue: 'Continuar',
  },
  settings: {
    chooseNetwork: 'Elegir red',
    chooseLanguage: 'Elegir idioma',
  },
  popup_CheckTask: {
    join: 'Unirse',
    check: 'Verificar',
    taskIsNotCompleted: 'Tarea no completada',
  },
  popup_levelUp: {
    levelUp: '¡Subiste de nivel!',
    multiTap: 'Multitoque',
    energyLimit: 'Límite de energía',
  },
  popup_BalanceUp: {
    balanceUp: '¡Actualización de saldo!',
    balanceDiffSinceLast: 'Tu recompensa',
  },
  popup_BalanceTip: {
    tip: 'Aumenta tu ganancia',
    message: 'Toca el menú Minar para comprar mejoras para tu red',
    description: 'Gana incluso cuando estás desconectado hasta por 3 horas',
  },
  popup_Bored: {
    header: '¡La rana está aburrida!',
    message: 'Juega con la rana.',
    description: 'Si no se juega con la rana durante 3 horas, la ganancia se detiene',
  },
  popup_Hungry: {
    header: '¡La rana tiene hambre!',
    message: 'Alimenta a la rana.',
    description: 'Cuantos más amigos tengas, más monedas puede traer cada alimentación',
  },
  menu: {
    network: 'Red',
    mine: 'Minar',
    earn: 'Ganar',
    food: 'Comida',
  },
  tap: {
    bored: 'Aburrido',
    fun: 'Divertido',
  },
  mineMenu: {
    activities: 'Actividades',
    investments: 'Inversiones',
    web3: 'WEB3',
    achievements: 'Logros',
  },
  leaderboard: {
    from: 'de',
    beTheFirst: '¡Sé el primero!',
  },
  mine: {
    joinOurTG1: 'Únete a nuestro canal de Telegram,',
    joinOurTG2: '¡para desbloquear!',
    unlock: 'Desbloquear',
  },
  friends: {
    inviteFriends: '¡Invita a tus amigos!',
    receiveBonuses: 'Tú y tu amigo recibirán bonificaciones',
    inviteFriend: 'Invitar a un amigo',
    withTelegramPremium: 'con Telegram Premium',
    forYouAndYourFriend: 'para ti y tu amigo',
    moreBonuses: 'Más bonificaciones',
    listOfYourFriends: 'Lista de tus amigos',
    linkCopied: '¡El enlace de invitación se ha copiado en tu portapapeles!',
    playWithMe:
      '¡Únete a mí y juega para ganar tokens a través de un airdrop!\n' +
      '💰 ¡Obtén tu regalo! +3000 monedas para los recién llegados\n' +
      '🚀 ¿Tienes Telegram Premium? ¡Obtén +5000 monedas!\n',
  },
  earn: {
    moreCoins: '¡Gana más monedas!',
    dailyTasks: 'Tareas diarias',
    dailyReward: 'Recompensa diaria',
    tasksList: 'Lista de tareas',
    joinOurTG: 'Únete a nuestro canal de Telegram',
    followOurX: 'Sigue nuestra cuenta de X',
    yourAd: 'Tu anuncio podría estar aquí',
    connect: 'Contacta al administrador de nuestro canal de Telegram',
  },
  food: {
    hungry: 'Hambriento',
    full: 'Lleno',
    frogIsFull: 'La rana está llena',
    feed: 'Alimentar',
    bonus: 'Bono',
    satiety: 'Saciedad',
    hours: 'horas',
  },
  toast: {
    buyCard: {
      title: '¡Logro desbloqueado!',
      subtitle: 'Es hora de llevar tu imperio de ranas a la grandeza 👑',
    },
    feedFrog: {
      title: '¡La rana está feliz!',
      subtitle: '¡Buen trabajo! Alimenta a tu mascota para mantener las sonrisas 🍽️',
    },
  },
};
